import { ToolTipIcon } from "components/icons/TooltipIcon";
import { SelectAutofillCombobox } from "components/SelectAutofillCombobox";
import { useFormikContext } from "formik";
import { personaAutoFillSalesTax } from "formValidations/autofillSchema";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useEffect, useState } from "react";
import { useGetAutofillQuery } from "store/apis/autofill";
import { SalesTaxBusinessPayload } from "store/apis/salesTax";

export const SalesTaxEntityOwnerDetails = () => {
  const group = useCurrentGroupContext();
  const entityId = group.entities?.[0]?.uuid;
  const { values, setFieldValue } = useFormikContext<
    SalesTaxBusinessPayload & {
      mailing_same_as_business_address: boolean;
    }
  >();
  const [hasMissingDetails, setHasMissingDetails] = useState(true);
  const { uuid: groupId } = useCurrentGroupContext();

  const { data: autofills = [] } = useGetAutofillQuery(
    {
      groupId,
      autofillKey: "authorized_persons",
      entityId,
    },
    { skip: !groupId || !entityId }
  );

  const currentAutofill = autofills.find((a) => a.uuid === values.owner_id);

  const validateData = async () => {
    try {
      await personaAutoFillSalesTax.validate(currentAutofill);
      setHasMissingDetails(() => false);
    } catch (error) {
      setHasMissingDetails(() => true);
    }
    setFieldValue("persona_details", currentAutofill);
  };

  useEffect(() => {
    if (currentAutofill) {
      validateData();
    } else {
      setHasMissingDetails(true);
    }
  }, [values.owner_id]);

  return (
    <div className="t-flex t-justify-center">
      <div className="t-w-[650px]">
        <div>
          <p className="t-text-title-h2-bold t-mb-1">Business owner details</p>
          <p className="t-text-body-sm t-text-text-30">
            This business information is required for enabling automated tax
            remittance.
          </p>
        </div>

        <div className="t-flex t-flex-col t-gap-4">
          <SelectAutofillCombobox
            type="authorized_persons"
            name="owner_id"
            onChange={(uuid) => {
              setFieldValue("owner_id", uuid);
            }}
            label="Business owner"
            placeholder="Select business owner"
            entityId={entityId}
            selected={values.owner_id}
            customValidation={{
              authorized_persons: personaAutoFillSalesTax,
            }}
          />
          {hasMissingDetails && (
            <p className="t-flex t-items-center t-text-red-50 t-text-body-sm -t-mt-3">
              Some required information is missing. Please provide the mandatory
              details to proceed.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
